/**
 *  Created by piotr@revisual.io on 15/03/2026
 */
import EventEngagementWidget from "./EventEngagementWidget";
import { useReportsStore } from "../../../../hooks/redux/reports";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

export const EventsStats = () => {
  const { reports, fetchEventsStats } = useReportsStore();
  const [range, setRange] = useState(7);
  const [activeTab, setActiveTab] = useState("upcoming");

  const history = useHistory();

  useEffect(() => {
    const tabHash = history.location.hash.slice(1);

    if (["upcoming", "past"].includes(tabHash)) {
      setActiveTab(tabHash);
    }
  }, [history.location.hash]);

  const { from, to } = useMemo(() => {
    const toTs = Math.floor(Date.now() / 1000);
    return { from: toTs - range * 86400, to: toTs };
  }, [range]);

  useEffect(() => {
    fetchEventsStats({
      from,
      to,
      sortField: "impressions",
      sortDirection: "desc",
      page: 1,
      limit: 5,
      // "upcoming" tab: real server-side filter.
      // "past" tab: no single status value covers ended+ongoing, so
      // this fetch is unfiltered and past excludes upcoming client-side below.
      status: activeTab === "upcoming" ? "upcoming" : undefined,
    });
  }, [activeTab, from, to, fetchEventsStats]);

  const onRangeChange = useCallback((r) => () => setRange(r), [setRange]);

  const onActiveTabChange = useCallback(
    (tab) => () => setActiveTab(tab),
    [setActiveTab]
  );

  const events = useMemo(
    () =>
      (reports.eventsCollection?.items || []).map((i) => ({
        ...i,
        date: new Date(i.start_date * 1000),
      })),
    [reports.eventsCollection]
  );

  const pastEvents = useMemo(
    () =>
      activeTab === "past"
        ? events.filter((e) => e.status !== "upcoming")
        : undefined,
    [events, activeTab]
  );

  const upcomingEvents = useMemo(
    () => (activeTab === "upcoming" ? events : undefined),
    [events, activeTab]
  );

  return (
    <EventEngagementWidget
      onRangeChange={onRangeChange}
      range={range}
      activeTab={activeTab}
      onActiveTabChange={onActiveTabChange}
      isLoading={reports.fetchEventsStats}
      pastEvents={pastEvents}
      upcomingEvents={upcomingEvents}
    />
  );
};

export default EventsStats;
